import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCoreDomain, CORE_API_ENTRYPOINT } from '@probatix/common/services/services.helpers'

import { getCurrentLocale } from '@probatix/common/translations'
import { AvailabilitesPayload, AvailableDaysParameters, AvailableDaysResponse } from './availabilitiesService.model'

const returnHeader = () => ({
  Accept: 'application/json',
  'Accept-Language': getCurrentLocale().code.slice(0, 2),
  'Content-Type': 'application/json',
})

// Define a service using a base URL and expected endpoints
export const availabilitiesApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    getAvailableDays: builder.query<AvailableDaysResponse, AvailableDaysParameters>({
       
      query: ({ locationKey, productKey }: AvailableDaysParameters) =>
        `${CORE_API_ENTRYPOINT}/api/v0/checkout/available-days/${productKey}/${locationKey}`,
    }),
    postAvailabilities: builder.mutation<any, AvailabilitesPayload>({
      query: ({ selectedDate, selectedLocation, selectedProduct }) => ({
        body: {
          selectedDate,
          selectedLocation,
          selectedProduct: '' === selectedProduct ? null : selectedProduct,
        },
        headers: returnHeader(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/v0/checkout/availabilities`,
      }),
    }),
  }),
  reducerPath: 'availabilitiesApi',
})

export const usePostAvailabilities = availabilitiesApi.endpoints.postAvailabilities.useMutation
export const useGetAvailableDays = availabilitiesApi.endpoints.getAvailableDays.useLazyQuery
